/**
 * This function is intended to escape the URL hash so that it can be used
 * in a jQuery selector
 *
 * There is some detail about escaping these characters on this page:
 * https://api.jquery.com/category/selectors/
 */
const escapeHashSelector = (hash) => {
    if (hash) {
        if (hash[0] === '#') {
            hash = hash.substring(1);
        }

        return `#${hash.replace(/([ #;?%&,.+*~':"!^$[\]()=>|/@])/g, '\\$1')}`;
    }
    return hash;
};

const getUrlParameter = (parameterName) => {
    const queryStringObject = new URLSearchParams(window.location.search);

    return queryStringObject.get(parameterName);
};

export {
    escapeHashSelector,
    getUrlParameter
};



// WEBPACK FOOTER //
// ./src/js/app/url-helper.js